import { UserActivitiesParams, UserActivitityResponse } from '@admin/organization/activities/types'
import { GET } from '../endpoints'
import { fetchData } from '../utils'

export function getUserActivities(params: UserActivitiesParams, signal?: AbortSignal) {
  return fetchData<UserActivitityResponse>({
    endpoint: GET.userActivities(),
    params,
    signal,
  })
}
